import * as Sentry from '@sentry/react';

// Normaliza o caminho para agrupar erros no Sentry: /alunos/abc-123 e
// /alunos/def-456 são a MESMA falha — sem isto viram grupos distintos no
// painel (e estouram o limite de cardinalidade das tags).
function endpointPattern(endpoint: string): string {
  return endpoint
    .split('?')[0]
    .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/:id')
    .replace(/\/\d+/g, '/:id');
}

// Nem toda resposta HTTP de erro deve virar evento — só 5xx (falha real do
// servidor). 4xx é uso esperado (validação, permissão, sessão expirada) e
// não deve poluir o painel.
function reportApiFailure(method: string, endpoint: string, status: number, message: string): void {
  if (status < 500) return;

  const pattern = endpointPattern(endpoint);
  Sentry.withScope((scope) => {
    scope.setTag('api_endpoint', pattern);
    scope.setTag('api_status', String(status));
    scope.setContext('request', { method, endpoint, status, message });
    Sentry.captureException(new Error(`API ${status} ${method} ${pattern}`));
  });
}

function reportNetworkFailure(method: string, endpoint: string, cause: unknown): void {
  const pattern = endpointPattern(endpoint);
  Sentry.withScope((scope) => {
    scope.setTag('api_endpoint', pattern);
    scope.setTag('api_status', 'network_error');
    scope.setContext('request', { method, endpoint });
    Sentry.captureException(cause instanceof Error ? cause : new Error(`Falha de rede em ${method} ${pattern}`));
  });
}

export { reportApiFailure, reportNetworkFailure, endpointPattern };
